import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Entry } from 'contentful';

import { ProfileService } from './services/profile/profile.service';
import { AuthService } from './services/auth/auth.service';
import { AnalyticsService } from './services/analytics/analytics.service';
import { GlobalContentService } from './services/global-content/global-content.service';
import { ContentfulService } from '../../src/app/core/contentful.service';

@Component({
  selector: 'app-old-view',
  templateUrl: './old-view.component.html',
  styleUrls: ['./old-view.component.scss'],
})
export class OldViewComponent implements OnInit {
  public disableFooter = false;
  public pageEnvironment: Promise<PageEnvironment>;

  constructor(
    private profileService: ProfileService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private contentfulService: ContentfulService,
  ) {}

  ngOnInit(): void {
    this.pageEnvironment = this.contentfulService.getDefaultEnvironment();
    this.profileService.catchInvitation();
    this.authService.handleRedirectResult();
    this.authService
      .isLoggedIn()
      .pipe(first())
      .subscribe((status) => {
        this.analyticsService.sendFirstPageWithLoginStatus(
          status ? 'logged-in' : 'logged-out',
        );
        this.analyticsService.handleRouteChange();
      });
  }

  onActivate(event): any {
    if (
      event.activatedRoute &&
      event.activatedRoute.snapshot &&
      event.activatedRoute.snapshot.data &&
      event.activatedRoute.snapshot.data &&
      event.activatedRoute.snapshot.data.disableFooter
    ) {
      this.disableFooter = true;
    } else {
      this.disableFooter = false;
    }
  }
}
